// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"8a62645c","839":"8897eefb"}[chunkId] + ".chunk.js";
};